import { render, staticRenderFns } from "./InvestmentAccountClaimPage.vue?vue&type=template&id=7d3644a2"
import script from "./InvestmentAccountClaimPage.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountClaimPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports